<db-dialog-wrapper [dialog]="this" [width]="'632px'" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading">
  <div class="db-push-to-live">
    <div class="push-to-live-title">{{'text_pushStagingEnvironmentLive' | dbText}}</div>
    <div class="push-to-live-description">
      <p [innerHTML]="'text_pushStagingConfirmDesc1' | dbText"></p>
    </div>
    <div class="confirmation-input">

      <form [formGroup]="pushToLiveForm" (ngSubmit)="confirm()">
        <input type="text" name="subdomain" formControlName="subdomain" [style.border-color]="(pushToLiveForm.controls['subdomain'].invalid && ((pushToLiveForm.controls['subdomain'].touched && !pushToLiveForm.controls['subdomain'].errors['required']) || formSubmitted))  ? '#E95E5B' : null" class="db-fc-input" [placeholder]="'text_confirmSubdomain' | dbText: { siteUrl: confirmationSubdomain }" />
        <div class="db-server-error-wrap">
          <div class="db-server-error-wrap">
            <div *ngIf="(pushToLiveForm.controls['subdomain'].invalid && ((pushToLiveForm.controls['subdomain'].touched && !pushToLiveForm.controls['subdomain'].errors['required']) || formSubmitted)) ">{{'text_domainNameWrongValidation' | dbText}}</div>
          </div>
        </div>
      </form>
    </div>

    <div class="push-to-live-buttons-wrap">
      <a class="db-button" (click)="cancel()" [ngClass]="{'db-button_disabled': loading}"><span>{{"text_cancel" | dbText}}</span></a>
      <a class="db-button db-button_info" [ngClass]="{'db-button_disabled': pushToLiveForm.controls['subdomain'].value === '' || loading}" (click)="confirm()">
        <span *ngIf="!loading">{{"text_hostingPushToLive" | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
